import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { userLogin } from 'store/action/user.action';
import { resetPassword } from 'store/action/email.action';
import Navbar from 'component/landing/navbar';
import Footer from 'component/landing/footer';

class Layout extends PureComponent {
  render() {
    const { userLogin, user, isAdmin } = this.props;
    return (
      <div
        className="height-screen flex-column justify-between flex-end"
        style={{ minHeight: '100%', backgroundColor: '#f7f7f7' }}
      >
        <Navbar />

        {this.props.children}

        <Footer />
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: user => dispatch(userLogin(user)),
    resetPassword: email => dispatch(resetPassword(email)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
